export default __webpack_public_path__ + "static/agent-builder-composer-real-8cb9a5b895383a76f725845aff1c6f7f.png";